export default __webpack_public_path__ + "static/media/reload.63e485ae.svg";